<template>
  <v-card flat>
    <FormField
      v-model="store.formData.correoRemitente"
      field-type="v-text-field"
      label="Email del remitente"
      type="email"
      placeholder="ejemplo@gmail.com"
      :rules="[rules.email]"
      class="mt-2"
      variant="outlined"
    />
  </v-card>
</template>

<script setup>
import { useSolicitudMensajeriaStore } from '@/stores/solicitudMensajeria'
import FormField from './FormField.vue'

const store = useSolicitudMensajeriaStore()

const rules = {
  email: (value) =>
    !value
      ? "Campo requerido"
      : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value) || "Correo invalido"
}
</script> 